"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
ProductService.$inject = ['api', '$q', 'ngDialog', '$timeout', 'FlickityService', '$location', '$document'];
function ProductService(api, $q, ngDialog, $timeout, FlickityService, $location, $document) {
    var service = {};
    var list = [];
    service.setList = function (products) {
        list = products;
    };
    service.getAttributes = function (_id) {
        return api.get('/b2b/product/' + _id + '/attributes');
    };
    service.getImages = function (_id) {
        return api.get('/b2b/product/' + _id + '/images');
    };
    service.viewProduct = function (product, index, mobile_title) {
        list[index].active = 'active';
        var delay = $q.defer();
        var editPanel = ngDialog.open({
            template: 'scripts/apps/shop/views/modal-product-view.html?v=1',
            appendClassName: 'custom-modal product-preview-modal',
            controller: ['$scope', '$document', '_analytics', function ($scope, $document, _analytics) {
                    $scope.current_location = $location.path();
                    $scope.product = product;
                    $scope.default_image_preview = product.default_image;
                    $scope.index = index;
                    $scope.items = list.length;
                    $scope.mobile_title = mobile_title != null ? mobile_title : 'Nazad';
                    $scope.damageType = {
                        1: "Oštećen za prodaju",
                        2: "Oštećena ambalaža",
                        3: "Nije funkcionalan"
                    };
                    $scope.$on('$locationChangeStart', function (event) {
                        if ($scope.current_location !== $location.path() ||
                            !$location.search().productView ||
                            $location.search().productView != $scope.product._id) {
                            if ($location.search().productView == undefined) {
                                $timeout(function () {
                                    ngDialog.close();
                                }, 0);
                                event.preventDefault();
                                return;
                            }
                            else {
                                var id_1 = $location.search().productView;
                                lodash_1.default.each(list, function (item, index) {
                                    if (item._id == id_1) {
                                        $scope.index = index;
                                        $scope.product = item;
                                        setNew();
                                    }
                                });
                            }
                        }
                    });
                    addAnalytic();
                    function addAnalytic() {
                        var data = {
                            "id": $scope.product._id,
                            "name": $scope.product.name,
                            "price": $scope.product.price
                        };
                        _analytics.viewItem(data);
                    }
                    $scope.$on('closeProductModal', function (event) {
                        event.preventDefault();
                        $timeout(function () {
                            ngDialog.close();
                        }, 0);
                    });
                    fetchAttributes();
                    fetchImages();
                    $scope.findNext = function () {
                        $scope.index = $scope.index + 1;
                        $scope.product = list[$scope.index];
                        $location.search('productView', $scope.product._id);
                        setNew();
                    };
                    $scope.findPrevious = function () {
                        $scope.index = $scope.index - 1;
                        $scope.product = list[$scope.index];
                        $location.search('productView', $scope.product._id);
                        setNew();
                    };
                    function setNew() {
                        $scope.default_image_preview = $scope.product.default_image;
                        fetchAttributes();
                        fetchImages();
                        lodash_1.default.each(list, function (child, index) {
                            child.active = '';
                        });
                        list[$scope.index].active = 'active';
                        addAnalytic();
                    }
                    function fetchAttributes() {
                        if (!$scope.product.attributes) {
                            service.getAttributes($scope.product._id).then(function (response) {
                                $scope.product.attributes = response;
                            }, function (error) {
                                console.log(error);
                            });
                        }
                    }
                    function fetchImages() {
                        if (!$scope.product.images) {
                            service.getImages($scope.product._id).then(function (response) {
                                $scope.product.images = response;
                                findDefault();
                                slider();
                            }, function (error) {
                                console.log(error);
                            });
                        }
                        else {
                            findDefault();
                            slider();
                        }
                    }
                    function findDefault() {
                        lodash_1.default.each($scope.product.images, function (img, index) {
                            if (img._default) {
                                $scope.default_image_preview = img.url;
                            }
                        });
                    }
                    $scope.init = true;
                    function slider() {
                        var width = $(window).width();
                        if ($('#imagesSlider') && width <= 769) {
                            FlickityService.destroy('imagesSlider').then(function (response) {
                                // console.log('destroy');
                                setSlider();
                            }, function (error) {
                                // console.log(error);
                                setSlider();
                            });
                        }
                    }
                    function setSlider() {
                        $scope.flickity_slider = {
                            cellAlign: 'left',
                            imagesLoaded: true,
                            pageDots: $scope.product.images.length > 1 ? true : false,
                            prevNextButtons: false,
                            contain: true,
                            wrapAround: true,
                            autoPlay: false
                        };
                        $timeout(function () {
                            var element = angular.element($document[0].getElementById('imagesSlider'));
                            // console.log(element);
                            // Initialize our Flickity instance
                            FlickityService.create(element[0], element[0].id, $scope.flickity_slider);
                        }, 0);
                    }
                    $scope.setDefault = function (image) {
                        lodash_1.default.each($scope.product.images, function (child, index) {
                            child._default = 0;
                        });
                        image._default = 1;
                        $scope.default_image_preview = image.url;
                    };
                    $scope.ok = function (response) {
                        delay.resolve(response);
                        ngDialog.close();
                    };
                    $scope.exit = function () {
                        ngDialog.close();
                    };
                }]
        });
        editPanel.closePromise.then(function (data) {
            $location.search('productView', null);
            lodash_1.default.each(list, function (child, index) {
                child.active = '';
            });
            FlickityService.destroy('imagesSlider').then(function (response) {
            }, function (error) {
                // console.log(error);
            });
            return true;
        });
        return delay.promise;
    };
    return service;
}
exports.ProductService = ProductService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/services/product.js
// module id = 359
// module chunks = 0